import * as React from "react"
import { PropsWithChildren } from "react"

import { ConferenceImage, ConferenceLink, Conferences, ConferencesContainer, ConferenceTitle, ConferenceSection } from "./styles"

import { useConferenceImages } from "../../../hooks/use-conference-images"

export interface ConferencesConfig {
  title: string;
}

export default function ConferencesComponent(props: PropsWithChildren<ConferencesConfig>) {
  const conferenceImages = useConferenceImages()

  const conferences = conferenceImages.map(conferenceImage => {
    return <ConferenceLink href={conferenceImage.href} target={"_blank"}>
      <ConferenceImage srcSet={conferenceImage.srcSet} alt={conferenceImage.alt}/>
    </ConferenceLink>
  })

  return (
    <Conferences>
      <ConferenceSection>
        <ConferenceTitle>{props.title}</ConferenceTitle>
        <ConferencesContainer>
          {conferences}
        </ConferencesContainer>
      </ConferenceSection>
    </Conferences>
  )
}
